// extracted by mini-css-extract-plugin
module.exports = {"container":"CategorySelector_container__JztN_","category":"CategorySelector_category__i6w34","active":"CategorySelector_active___RFyp"};